import { RefreshCw, X } from 'lucide-react';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';
import { Button } from '../ui/button';

export default function UpdateBanner() {
  const { updateAvailable, isApplying, applyUpdate, dismissUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="border-b border-brand-info/30 bg-brand-info/15 px-4 py-2.5 text-sm text-[var(--ba-body-text)]"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-3">
        <p className="inline-flex items-center gap-2 text-center">
          <RefreshCw className="h-4 w-4 shrink-0 text-brand-info" aria-hidden />
          <span>
            <strong>Nuova versione disponibile.</strong> Aggiorna per usare l&apos;ultima release.
          </span>
        </p>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            size="sm"
            variant="info"
            onClick={applyUpdate}
            disabled={isApplying}
          >
            <RefreshCw className={`h-4 w-4 ${isApplying ? 'animate-spin' : ''}`} />
            {isApplying ? 'Aggiornamento…' : 'Aggiorna ora'}
          </Button>
          <button
            type="button"
            onClick={dismissUpdate}
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-[var(--ba-muted)] transition-colors hover:bg-black/5 hover:text-[var(--ba-body-text)] dark:hover:bg-white/10"
            aria-label="Chiudi avviso aggiornamento"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
